/* Copyright Information: Created by BuyGroup */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import HomePage from "../../Home/HomePage";
import Category from "../Category/Category";
import Cart from "../../Cart/Cart";
import ViewProduct from "../product/ViewProduct";
import SearchProduct from "../../SearchProduct/SearchProduct";
import Account from "../../Account/Account";
import ContactUs from "../Pages/ContactUs";
import FAQ from "../Pages/FAQ";
// import PrivacyPolicy from "../Pages/PrivacyPolicy";
// import TermsCondition from "../Pages/TermsCondition";
import Checkout from "../../Checkout/Checkout";
import PlaceOrderSuccess from "../../Checkout/PlaceOrderSuccess";
import BillingAddress from "../../Account/ManageAddress/BillingAddress";
import ShippingAdress from "../../Account/ManageAddress/ShippingAdress";

import Home from "../Home/Home";
import { isLoggedIn } from "../../utils";
import QuoteListing from "../../Quote/QuoteListing";
import CreateEditQuote from "../../Quote/CreateEditQuote";
import ViewQuote from "../../Quote/ViewQuote";
import QuoteCheckout from "../../Quote/QuoteCheckout";

export default class HomeContainer extends React.Component {
  render() {
    return (
      <div
        className={
          this.props.handleMainClass
            ? "main-container min-height"
            : "main-container full min-height"
        }
        id="main-container"
      >
          <Switch>
            <Route exact path="/category/:id" component={Category} />
            <Route exact path="/search/:name" component={SearchProduct} />
            <Route exact path="/cart" component={Cart} />
            <Route exact path="/checkout" component={Checkout} />
            <Route exact path="/order-success" component={PlaceOrderSuccess} />
            <Route exact path="/dashboard" component={Account} />
            <Route exact path="/product/:id" component={ViewProduct} />
            <Route exact path="/faq" component={FAQ} />
            {/* <Route exact path="/privacy-policy" component={PrivacyPolicy} /> */}
            {/* <Route exact path="/termscondition" component={TermsCondition} /> */}
            <Route exact path="/contactus" component={ContactUs} />
            <Route exact path="/billingAddress" component={BillingAddress} />
            <Route exact path="/shippingAdress" component={ShippingAdress} />
            <Route exact path="/quote" component={QuoteListing} />
            <Route exact path="/quote/create" component={CreateEditQuote} />
            <Route exact path="/quote/edit/:id" component={CreateEditQuote} />
            <Route exact path="/quote/:id" component={ViewQuote} />
            <Route exact path="/quote/checkout/:id" component={QuoteCheckout} />

            <Route exact path="/public" component={HomePage} />

            {/* <Route
              path="/"
              render={(props) => {
                if (isLoggedIn()) {
                  return <HomePage {...props} />;
                }
                return <Home {...props} />;
              }}
            /> */}

            {/* <Route path="/" render={(props) => <HomePage {...props} />} /> */}
            {/* <Route path="/" render={(props) => <Home {...props} />} /> */}

            <Route
              path="/"
              render={(props) => {
                if (isLoggedIn()) {
                  return <Redirect to="/public" />;
                }

                const params = new URLSearchParams(props.location.search);
                const accessCode = params.get("accessCode");

                if (accessCode && accessCode.trim() !== "") {
                  return <HomePage {...props} />;
                }

                return <Home {...props} />;
              }}
            />
          </Switch>
      </div>
    );
  }
}
/* Copyright Information: Created by BuyGroup */
